import { render, staticRenderFns } from "./PackageAdd.vue?vue&type=template&id=bbdfba6e&"
import script from "./PackageAdd.vue?vue&type=script&lang=js&"
export * from "./PackageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageAdd.vue"
export default component.exports